import { SvgIcon, SvgIconProps } from "@mui/material";
import HomeIconSvg from "../../assets/svg/home-icon.svg?react";

const HomeIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <HomeIconSvg fill="currentColor" />
    </SvgIcon>
  );
};

export { HomeIcon };
